module.exports = __webpack_public_path__ + "img/lb.b1427249.png";